import { CLOUDFRONT_VIEWER_COUNTRY_COOKIE_NAME } from "constants/cookies";
import { setCookie } from "services/cookies-service";
export const saveCloudfrontViewerCountryCookie = (cloudfrontViewerCountry)=>{
    cloudfrontViewerCountry && setCookie(CLOUDFRONT_VIEWER_COUNTRY_COOKIE_NAME, cloudfrontViewerCountry);
};
